import * as React from 'react';

import {Button} from 'shells/button/button';
// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from 'shells/icon/svg/external-link-icon';
import {UpgradePillButton} from 'shells/limits/upgrade-pill-button';

import {getDataTipText} from './helpers';

import styles from '../security-page.module.css';

type Props = {
    canSetup: boolean;
    isConfigured: boolean;
    setIsFeatureGateModalOpen: (isOpen: boolean) => void;
    disableRef: {
        current: HTMLElement | null | undefined;
    };
    setIsDisableSsoConfirmationOpen: (isOpen: boolean) => void;
    onManageSso: () => void;
    onSetupSso: () => void;
    canDisableSso: boolean;
};

export function SsoConfigureButtons(props: Props) {
    if (!props.canSetup) {
        return (
            <div className='flex flex-grow justify-end'>
                <UpgradePillButton
                    onClick={() => props.setIsFeatureGateModalOpen(true)}
                    size='small'
                />
            </div>
        );
    } else if (props.isConfigured) {
        return (
            <div className='flex gap-8 flex-grow justify-end'>
                <Button
                    variant='primary'
                    size='small'
                    onClick={props.onManageSso}
                    icon={ExternalLinkIcon}
                >
                    Manage
                </Button>
                <div
                    // @ts-expect-error
                    ref={props.disableRef}
                    data-tip-width='240px'
                    data-tip={getDataTipText(props.canDisableSso || false)}
                >
                    <Button
                        variant='secondary'
                        size='small'
                        onClick={() => props.setIsDisableSsoConfirmationOpen(true)}
                        disabled={!props.canDisableSso}
                    >
                        Disable
                    </Button>
                </div>
            </div>
        );
    } else if (!props.isConfigured) {
        return (
            <div className='flex flex-grow justify-end'>
                <Button variant='primary' size='small' onClick={() => props.onSetupSso()}>
                    <div className='flex align-center gap-6'>
                        <div className={styles['sso-icon-in-button']}>
                            <ExternalLinkIcon size={14} />
                        </div>
                        Configure
                    </div>
                </Button>
            </div>
        );
    } else {
        return null;
    }
}
